var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('functional-calendar',{attrs:{"configs":_vm.calendarConfigs},on:{"selectedDaysCount":_vm.selectedDaysCount},model:{value:(_vm.calendarData),callback:function ($$v) {_vm.calendarData=$$v},expression:"calendarData"}})}
var staticRenderFns = []

export { render, staticRenderFns }